import React, { lazy, Suspense } from "react";
import { OrderedMap } from "immutable";
import Card from "antd/lib/card";

class Registry {
  getComponent(componentName) {
    const Component = components.get(componentName);

    const ComponentLoader = class extends React.Component {
      render() {
        // console.log(componentName, this.props)
        return (
          <React.Fragment>
            <Suspense
              fallback={<Card style={{ height: "100%" }} loading={true} />}
            >
              <Component {...this.props} />
            </Suspense>
          </React.Fragment>
        );
      }

      displayName = componentName;
    };

    return ComponentLoader;
  }

  // getForm(formName) {
  //     const Component = components.getIn(["forms", formName]);
  //     // console.log(Component)
  //     const ComponentLoader = class extends React.Component {

  //         render() {
  //             // console.log("LOADED")
  //             return (
  //                 <React.Fragment>
  //                     <Suspense fallback={<div>Loading ...</div>}>
  //                         <Component {...this.props} />
  //                     </Suspense>
  //                 </React.Fragment>
  //             )
  //         }

  //         displayName = formName
  //     };

  //     return ComponentLoader;
  // }

  getIcon(iconName) {
    const Component = components.getIn(["icons", iconName]);
    const ComponentLoader = class extends React.Component {
      render() {
        return (
          <React.Fragment>
            <Suspense fallback={<Card loading={true} />}>
              <Component {...this.props} />
            </Suspense>
          </React.Fragment>
        );
      }

      displayName = iconName;
    };

    return ComponentLoader;
  }
}

const components = new OrderedMap({
  "router.tabs": lazy(() => import("./components/router/tab-router")),
  "pages.dashboard": lazy(() => import("./pages/dashboard")),
  "pages.dashboard2": lazy(() => import("./pages/dashboard/dashboard2")),
  "pages.dotnet.dashboard": lazy(() => import("./pages/dotnet/dashboard")),
  "pages.django.dashboard": lazy(() => import("./pages/django/dashboard")),
  "pages.dashboard.form-test": lazy(() =>
    import("./pages/dashboard/form-test")
  ),
  "pages.test": lazy(() => import("./pages/test")),
  "pages.zeta.accountTransactions": lazy(() =>
    import("./pages/zeta/account-transactions")
  ),
  "pages.zeta.personAccountTransactions": lazy(() =>
    import("./pages/zeta/person-account-transactions")
  ),
  "pages.dispatch": lazy(() => import("./pages/dispatch")),
  "pages.dispatch.dispatchFiles": lazy(() =>
    import("./pages/dispatch/dispatch-files")
  ),
  "pages.dispatch.dispatchCards": lazy(() =>
    import("./pages/dispatch/dispatch-cards")
  ),
  "pages.dispatch.dispatchCardsM2p": lazy(() =>
    import("./pages/dispatch/dispatch-cards-m2p")
  ),
  "pages.dispatch.upload": lazy(() =>
    import("./pages/dispatch/dispatch-file-upload")
  ),
  "pages.paytm.paytmOrders": lazy(() => import("./pages/paytm/paytm-orders")),
  "pages.referrals.rewardsList": lazy(() =>
    import("./pages/referrals/rewards-list")
  ),
  "pages.dummy": lazy(() => import("./pages/dummy")),
  "forms.editTableCell": lazy(() => import("./forms/edit-table-action")),
  "forms.runTableAction": lazy(() => import("./forms/run-table-action")),
  "pages.users.search": lazy(() => import("./pages/users/search")),
  "pages.auth.login": lazy(() => import("./pages/auth/login")),
  metabase: lazy(() => import("./components/metabase")),
  "pages.cashback.upload": lazy(() =>
    import("./pages/cashback/cashback-file-upload")
  ),
  "pages.cashback.cashbackFiles": lazy(() =>
    import("./pages/cashback/cashback-files")
  ),
  "pages.cashback.refund.upload": lazy(() =>
    import("./pages/cashback/refund-file-upload")
  ),
  "pages.cashback.refund.files": lazy(() =>
    import("./pages/cashback/refund-files")
  ),
  "modals.confirmAction": lazy(() => import("./modals/confirm-action-modal")),
  "modals.editAction": lazy(() => import("./modals/edit-action-modal")),
  "modals.pollingAction": lazy(() => import("./modals/polling-action-modal")),
  "modals.dispatchBucketAction": lazy(() =>
    import("./pages/dispatch/dispatch-bucket-action")
  ),
  "pages.dispatch.expanded-row": lazy(() =>
    import("./pages/dispatch/expanded-row")
  ),
  "pages.dispatch.download-button": lazy(() =>
    import("./pages/dispatch/dispatch-download-action")
  ),
  "pages.dispatch.upload-button": lazy(() =>
    import("./pages/dispatch/dispatch-upload-action")
  ),
  "pages.expanded-row.orders": lazy(() =>
    import("./pages/expanded-row/orders-expanded")
  ),
  "pages.notifications.dashboard": lazy(() =>
    import("./pages/notifications/dashboard")
  ),
  "pages.notifications.events-list": lazy(() =>
    import("./pages/notifications/events-list")
  ),
  "pages.notifications.templates-list": lazy(() =>
    import("./pages/notifications/templates-list")
  ),
  "pages.notifications.expanded-row": lazy(()=>
    import("./pages/notifications/expanded-template")
  ),
  "pages.orders.allOrders": lazy(() =>
    import("./components/table/django/orders-list")
  ),
  "pages.orders.cashfree-transactions": lazy(() =>
    import("./pages/orders/cashfree-transactions-list")
  ),
  "pages.orders.payment-mode-cell": lazy(() =>
    import("./pages/orders/payment-mode-cell")
  ),
  "pages.orders.actions-cell": lazy(() =>
    import("./pages/orders/actions-cell")
  ),
  "pages.sub-orders.actions-cell": lazy(() =>
    import("./pages/orders/suborder-actions-cell")
  ),
  "pages.order.bulk-retry-action": lazy(() =>
    import("./pages/orders/bulk-retry-action")
  ),
  "pages.orders.txn-details-cell": lazy(() =>
    import("./pages/orders/txn-details-cell")
  ),
  "pages.orders.payment-order": lazy(() =>
    import("./pages/orders/payment-order")
  ),
  "pages.system.statistics": lazy(() =>
    import("./pages/system/system-statistics")
  ),
  "pages.audit.otpLogs": lazy(() => import("./pages/audit/otp-logs")),
  "pages.audit.uploadForm": lazy(() => import("./pages/audit/otp-logs-upload")),
  "pages.audit.paymentKits": lazy(()=> import("./pages/audit/payment-kits")),
  "modals.details-object-cell": lazy(()=> import("./modals/detailed-object-cell")),
  "pages.cashfree.syncButton": lazy(() => import("./pages/orders/cashfree-sync-button")),
  "pages.crossword.crossword": lazy(() => import("./pages/crossword/crossword-main")),
  'pages.cms.strapi': lazy(() => import("./pages/cms/strapi")),
  "pages.cms.qwikcilver.list": lazy(() => import("./pages/cms/qwikcilver-listing")),
  "pages.cms.qwikcilver.categories": lazy(() => import("./pages/cms/qwk-category-listing")),
  "pages.cms.short-url.list": lazy(() => import("./pages/cms/short-url-listing")),
  "pages.cms.short-url.generator": lazy(() => import("./pages/cms/short-url-generator")),
  "pages.cms.service-controls": lazy(() => import("./pages/cms/service-controls")),
  "service-controls.flag-update-action": lazy(() => import("./pages/cms/service-control-actions/flag-update")),
  "cms.service-controls.add-flag": lazy(() => import("./pages/cms/service-control-actions/flag-update")),
  "pages.cms.uploaded-files": lazy(() => import("./pages/cms/files-upload-listing")),
  "pages.cms.file-upload": lazy(()=>import("./pages/cms/file-upload")),
  "actions.download-csv": lazy(() => import("./components/download-csv")),
  "pages.finchamps.users": lazy(() => import("./pages/finchamps/users")),
  "pages.finchamps.quiz": lazy(() => import("./pages/finchamps/quiz")),
  "pages.holiparty.task-completed": lazy(() => import("./pages/holiparty/task-completed")),
  "pages.expanded-row.accountTxns": lazy(()=>import("./pages/expanded-row/account-txns-expanded")),
  "modals.accountDeletion": lazy(()=>import("./modals/account-deletion-modal"))
  // "pages.cases": lazy(() => import("./pages/case-list")),
  // "pages.case": lazy(() => import("./pages/case")),
  // "pages.case.applicants": lazy(() => import("./pages/case.applicants")),
  // "pages.case.checklist": lazy(() => import("./pages/case.checklist")),
  // "pages.case.documents": lazy(() => import("./pages/case.documents")),
  // "pages.case.documents.entity": lazy(() => import("./pages/case.documents.entity")),
  // "pages.case.documents.pendency": lazy(() => import("./pages/case.documents.pendency")),
  // "pages.case.pd": lazy(() => import("./pages/case.pd")),
  // "applicants.edit": lazy(() => import("./forms/applicants.edit")),
  // "case.create": lazy(() => import("./forms/case.create")),
  // "documents.pendency.add": lazy(() => import("./forms/documents.pendency.add")),
  // "forms.distributor.add": lazy(() => import("./forms/distributor.add")),
  // "forms.case.proposed-limit.edit": lazy(() => import("./forms/case.proposed-limit.edit")),
  // "components.stage-pipeline": lazy(() => import("./components/stage-pipeline")),
  // "pages.crm": lazy(() => import("./pages/crm")),
  // "pages.case-crm": lazy(() => import("./pages/case-crm")),
  // "crm.details.form": lazy(() => import("./forms/crm.details.form"))
});

const componentRegistry = new Registry();
export class ComponentLoader extends React.Component {
  render() {
    const Component = components.get(this.props.componentName);
    return (
      <React.Fragment>
        <Suspense fallback={<Card style={{ height: "100%" }} loading={true} />}>
          <Component {...this.props} />
        </Suspense>
      </React.Fragment>
    );
  }
}

export default componentRegistry;
